import { ProvenanceChip } from '@/components/ui/provenance-chip';
import { cn } from '@/lib/utils/cn';
import type { DocumentSharePointSource } from '@/lib/api/documents';

/**
 * The provenance of a document the connected SharePoint folder took
 * (E18-F01 / T-0211): the `SharePoint` chip — the shared provenance chip
 * primitive — linking to the file in SharePoint in a new tab. Nothing for a
 * document without a source. Shown on the document card and the document
 * detail.
 */
export function SharePointChip({
  source,
  className,
}: {
  source: DocumentSharePointSource | null | undefined;
  className?: string;
}) {
  if (!source) return null;
  return (
    <a
      href={source.web_url}
      target="_blank"
      rel="noreferrer"
      className={cn(
        'inline-flex flex-none rounded-full no-underline hover:underline',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-amber-600',
        className,
      )}
    >
      <ProvenanceChip origin="sharepoint" />
    </a>
  );
}
